import React from 'react';

const About = () => {
    return (
        <div className='h-screen'>
            <h3 className='text-5xl text-center text-white p-16'>About Me</h3>
            <div className='text-white bg-cyan-600 p-12'>
                <p className='my-4'>
                    Highly motivated entry-level Web Developer who is actively looking for a job position similar to Junior Front-End Developer/ Junior Full Stack Developer (MERN Stack).
                </p>
                <p className='my-4'>
                    Ready to join a team with a great working and learning environment so that I can contribute to the company I will be working for in every aspect.
                </p>
                <p className='my-4'>
                    Have built some projects with React.js and MERN stack where I implemented Firebase Authentication, CRUD operation, and developed Admin dashboard. Made all the projects mobile-friendly and responsive using either Bootstrap or TailwindCSS.
                </p>
            </div>
        </div>
    );
};

export default About;